import Home from './Home.vue'
import Login from './components/Login.vue'
import Register from './components/Register.vue'
import RegistrationSuccess from './components/RegistrationSuccess.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import ForgotPassword2 from './components/ForgotPassword2.vue'
import Users from './components/Users.vue'
import Messages from './components/Messages.vue'
import Dashboard from './components/Dashboard.vue'





export const routes = [
    {
        path: '/',
        name:'Home',
        component:Home
    },
    {
        path: '/Login',
        name:'Login',
        component:Login
    }, 
    {
        path: '/Register',
        name:'Register',
        component:Register
    },
    {
        path: '/RegistrationSuccess',
        name:'RegistrationSuccess',
        component:RegistrationSuccess
    },
    {
        path: '/ForgotPassword',
        name:'ForgotPassword',
        component:ForgotPassword
    },
    {
        path: '/ForgotPassword2',
        name:'ForgotPassword2',
        component:ForgotPassword2
    },
    {
        path: '/Users',
        name:'Users',
        component:Users
    
    },
    {
        path: '/Messages',
        name:'Messages',
        component:Messages
    },
    {
        path: '/Users', component: Dashboard,  beforeEnter (to, from, next) {
            if (localStorage.token) {
              next()
            } else {
              next('/Login')
            }
          }, children: [
            {
                path: '', component: Users
            },
            { 
                path: '/Messages', component: Messages
            }
        ]
    }
    
    
    
]
